var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"display-text"},[_vm._v("\n  "+_vm._s(_vm.displayText.join(""))+"\n  "),_c('span',{staticClass:"cursor"},[_vm._v("|")])])
}
var staticRenderFns = []

export { render, staticRenderFns }